import React from 'react';
import styles from './FooterOptions.module.scss';
import { checkIfEmailIsVerifiedOrNot } from '../contexts/UserContext';

export default function FooterOptions(props) {
  return (
    <div
      className={`${props?.className} ${styles.footerContainer} ${
        !checkIfEmailIsVerifiedOrNot(false) ? 'bottom-space-footer-action' : ''
      } hide-hub-spot-icon`}>
      {props?.children}
    </div>
  );
}
